if (!customElements.get('feat-collections-tabs')) {
    customElements.define(
        'feat-collections-tabs',
        class FeatCollectionsTabs extends HTMLElement {
            constructor() {
                super();
                this.tabs = this.querySelectorAll('button');
                this.glides = this.closest('section').querySelectorAll('glide-component');
                if (!this.tabs) return;
                if (!this.glides) return;

                this.tabs.forEach((button) =>
                    button.addEventListener('click', this.onTabClick.bind(this))
                );
            }

            onTabClick(event) {
                event.preventDefault();
                const button = event.target;
                const target = button.dataset.target;
                const buttonSiblings = button.closest('div').querySelectorAll('button');

                buttonSiblings.forEach((button) => {
                    button.classList.remove('button--primary');
                    button.classList.add('button--secondary');
                });
                button.classList.remove('button--secondary');
                button.classList.add('button--primary');

                this.glides.forEach((glide) => {
                    if (glide.id == target) {
                        glide.classList.remove('hidden');
                        window.dispatchEvent(new Event('resize'));
                    } else {
                        glide.classList.add('hidden');
                    }
                });
            }
        }
    );
}
